export const faqs = [
  {
    q: "吃瓜前线的「实时楼」是怎么更新的？",
    a: "实时楼会按照事件发生的时间顺序持续追加条目，每条都会标注大致时间与信息来源类型。我们只整理已经公开传播的内容，并在同一话题下保留前后文，方便你对照着看事情怎么一步步发展。",
  },
  {
    q: "「秒删截图」类内容你们会怎么处理？",
    a: "对于已经公开传播又很快被删除的内容，我们会先核对是否存在多个独立来源，再以文字摘要为主、原图谨慎处理的方式呈现，避免二次扩散可能涉及个人隐私的信息。涉及私域聊天与个人身份的内容不会收录。",
  },
  {
    q: "网站内容多久更新一次？",
    a: "热点榜每小时刷新一次排序，分类页与专题页通常每天集中更新两到三次。遇到讨论量快速上升的话题，会临时加开一条实时楼持续跟进到讨论自然回落。",
  },
  {
    q: "我可以提供线索吗？",
    a: "可以。你可以通过联系我们页面提交公开可见的线索来源，我们会先做来源核验，确认属于公开讨论范围后才会考虑整理成话题。请勿提交涉及他人隐私、身份信息或未经证实的指控内容。",
  },
  {
    q: "为什么有些热门话题在站内搜不到？",
    a: "如果话题主要围绕个人隐私、未经证实的指控或可能引发群体对立的内容，我们会选择不收录。这是内容原则的一部分，目的是让这里更像一个可以安心浏览的热点档案馆。",
  },
  {
    q: "站内内容可以转载吗？",
    a: "站内原创的时间线梳理与速览文字，注明来源并保留原文链接即可引用。图片与视频片段版权归原作者所有，转载前请自行确认授权，我们对二次转载不承担连带责任。",
  },
];